import { CardContent, Grid, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { MUIDataTableColumn } from 'mui-datatables';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Card from '../../../../components/Card';
import CustomDataTable from '../../../../components/CustomDataTable';
import SelectPeriod from '../../../../components/SelectPeriod';
import TableSkeleton from '../../../../components/TableSkeleton';
import { ObservationDTO } from '../../../../models/dto/ObservationDTO';
import { PeriodDTO } from '../../../../models/dto/PeriodDTO';
import { findObservations } from '../../../../services/personnelDepartment.service';
import { AppState } from '../../../../store';
import { CondominiumReducerData } from '../../../../store/reducers/condominiumReducer';
import { EmployeesReducerData } from '../../../../store/reducers/employeesReducer';
import { convertMinutesToHours } from '../../../../utils/convertMinutesToHours';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chip: {
      margin: '5px 0 5px 10px',
    },
    root: {
      height: '100%',
    },
    cardHeaderContainer: {
      padding: theme.spacing(2),
      paddingTop: theme.spacing(1),
      paddingBottom: 0,
    },
    cardContentContainer: {
      height: 'calc(100% - 54px)',
    },
  }),
);

const PunchCardObservationsTableCard: React.FC = () => {
  const classes = useStyles();
  const [tableData, setTableData] = useState<ObservationDTO[]>([]);
  const [periodSelected, setPeriodSelected] = useState<PeriodDTO | null>(null);
  const [loadingData, setLoadingData] = useState<boolean>(false);
  // const [chipFilterSelected, setChipFilterSelected] = useState<
  //   TableDataFilterOptions
  // >('ALL');

  const { condominiumSelected }: CondominiumReducerData = useSelector(
    (state: AppState) => state.condominiumReducer,
  );

  const { employees }: EmployeesReducerData = useSelector(
    (state: AppState) => state.employeesReducer,
  );

  const columns: MUIDataTableColumn[] = [
    {
      name: 'criadoEm',
      label: 'Data de Criação',
    },
    {
      name: 'numeroCadastro',
      label: 'Funcionário',
      options: {
        customBodyRender: (value: any, _tableMeta: any, _updateValue: any) =>
          employees.find(employee => employee.numeroCadastro === value)?.nome,
      },
    },
    {
      name: 'gratificacao',
      label: 'Tipo de Observação',
    },
    {
      name: 'observacao',
      label: 'Observação',
    },
    {
      name: 'quantidadeMinutos',
      label: 'Qtd. Horas',
      options: {
        customBodyRender: (value: any, _tableMeta: any, _updateValue: any) =>
          convertMinutesToHours(value, ':'),
      },
    },
    {
      name: 'valorBonificacao',
      label: 'Valor da Bonificação',
      options: {
        customBodyRender: (value: any, _tableMeta: any, _updateValue: any) =>
          `R$ ${value}`,
      },
    },
  ];

  const getTableData = async (reference: number, period: PeriodDTO) => {
    try {
      setLoadingData(true);
      const { data } = await findObservations({
        reference,
        period,
      });
      setTableData(data.sort((a, b) => (a.id < b.id ? 1 : -1)));
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingData(false);
    }
  };

  useEffect(() => {
    if (condominiumSelected && periodSelected) {
      getTableData(condominiumSelected.referencia, periodSelected);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [condominiumSelected, periodSelected]);

  return (
    <Card style={{ height: '100%' }}>
      <Grid
        container
        alignItems="center"
        justify="space-between"
        className={classes.cardHeaderContainer}
      >
        <Grid item>
          <Typography color="textSecondary" variant="h5">
            Observações
          </Typography>
        </Grid>
        <Grid item>
          <SelectPeriod
            showLabel
            disableUnderline
            value={periodSelected}
            handlePeriodChange={setPeriodSelected}
          />
        </Grid>
      </Grid>

      <CardContent className={classes.cardContentContainer}>
        <>
          {loadingData ? (
            <TableSkeleton rows={3} />
          ) : (
            <CustomDataTable
              data={tableData.sort((a, b) => (a.id < b.id ? 1 : -1))}
              columns={columns}
              options={{
                elevation: 0,
                tableBodyHeight: 'calc(100% - 150px)',
              }}
              title=""
            />
          )}
        </>
      </CardContent>
    </Card>
  );
};

export default PunchCardObservationsTableCard;
